import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    save_as_pdf_button_history: {
      id: 'save_as_pdf_button_history',
      defaultMessage: "Save shown records in PDF",
      description: '',
    },
    from_date_history_text: {
      id: 'from_date_history_text',
      defaultMessage: "From date:",
      description: '',
    },
    to_date_history_text: {
      id: 'to_date_history_text',
      defaultMessage: "To date:",
      description: '',
    },
    download_history_text: {
      id: 'download_history_text',
      defaultMessage: "Download history",
      description: '',
    },
    download_pressure_log_text: {
      id: 'download_pressure_log_text',
      defaultMessage: "Download degass log",
      description: '',
    },
    history_download_failed: {
      id: 'history_download_failed',
      defaultMessage: "History download failed. History files have not been sent in preset time.",
      description: '',
    },
    files_count_downloaded: {
      id: 'files_count_downloaded',
      defaultMessage: "Downloaded files",
      description: '',
    },
    no_files_text: {
      id: 'no_files_text',
      defaultMessage: "No files",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/Messages.js